<template>
  <div class="d-ib">
    <el-button
        type="primary"
        class="btn-main"
        icon="el-icon-search"
        @click="setDialog(true)"
    >
      Filters
    </el-button>
    <el-dialog
        title="Filters"
        :visible="dialog"
        width="500px"
        top="3vh"
        :modal="true"
        @close="setDialog(false)"
    >
      <el-select
          v-model="channel"
          placeholder="Channel"
          clearable
          filterable
          class="w100"
      >
        <el-option
            v-for="(r, i) in channels"
            :key="i"
            :label="r.channel_id"
            :value="r.channel_id"
        ></el-option>
      </el-select>
      <el-select
          v-model="user_status"
          placeholder="Status"
          clearable
          filterable
          class="mt10 w100"
      >
        <el-option value="claimed" label="Claimed"></el-option>
        <el-option value="no claim" label="Not Claimed"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      channel: '',
      status: '',
    }
  },
  computed: {
    ...mapState('channelVideoClaims', ['dialog', 'channels'])
  },
  methods: {
    ...mapMutations('channelVideoClaims', ['setDialog', 'setFilter']),
    ...mapActions('channelVideoClaims', ['readChannels','readVideos']),

    filter() {
      this.setFilter({
        channel: this.channel,
        status: this.user_status,
      })
      this.readVideos()
      this.setDialog(false)
    },

    clear() {
      this.setFilter({})
      this.readVideos()
      this.channel = ''
      this.status = ''
      this.setDialog(false)
    }
  }
}
</script>
